import { useEffect, useRef } from "react";

// Soft crimson/gold spotlight that follows the pointer. Skipped on touch devices
// and for users who prefer reduced motion.
export default function CursorGlow() {
  const ref = useRef(null);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduce) return undefined;

    const el = ref.current;
    let x = window.innerWidth / 2, y = window.innerHeight / 2, tx = x, ty = y, raf;
    const move = (e) => { tx = e.clientX; ty = e.clientY; el.style.opacity = "1"; };
    const leave = () => { el.style.opacity = "0"; };
    const tick = () => {
      x += (tx - x) * 0.14;
      y += (ty - y) * 0.14;
      el.style.transform = `translate3d(${x - 250}px, ${y - 250}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    window.addEventListener("pointermove", move);
    document.addEventListener("pointerleave", leave);
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("pointermove", move);
      document.removeEventListener("pointerleave", leave);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="fixed top-0 left-0 pointer-events-none"
      style={{
        width: 500,
        height: 500,
        opacity: 0,
        zIndex: 5,
        transition: "opacity 0.5s ease",
        background: "radial-gradient(circle, rgba(201,162,75,0.10) 0%, rgba(155,27,27,0.07) 40%, transparent 70%)",
        mixBlendMode: "screen",
      }}
    />
  );
}
